module.exports = __webpack_public_path__ + "img/rootcove.454c16a8.svg";